// tsc does not recognize jsx extension therefor renaming to tsx
import AuthProvider from '../providers/AuthProvider';

/**
 * Handles successful signIn
 * @returns {AuthConsumer}
 * @constructor
 */
export const SignedInCallback = () => AuthProvider.createConsumer('signedInRedirectCallback', 'Ajax.signedInMessage');
